import React from "react";
import PropTypes from "prop-types";
import STRINGS from "Constants/Strings";
import NumberFormat from "react-number-format";
import MaskedInput from "react-text-mask";
import AppConstants from "Constants/AppConstants";
import AuthBody from "../Common/AuthBody/AuthBody";
import Stepper from "../Common/Stepper/Stepper";
import VALIDATIONS from "../../Constants/ValidationList";
import checkErrors from "../../Utils/InputValidator";
import ROUTES from "../../Constants/AppConstants";

class BusinessAboutYou extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nonMember: false,
      show: [],
      foundMemberList: [],
      additionalMemberList: [],
    };
  }

  componentDidMount() {
    const { getDataFromServer } = this.props;

    getDataFromServer(
      AppConstants.APPLICATIONSTEP.BUSINESS_ABOUT_YOU,
      (response) => {
        this.setFormData(response);
      }
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.activeProduct !== this.props.activeProduct) {
      this.setFormData();
    }
  }

  setFormData = (data) => {
    const { activeProduct } = this.props;
    let memberSelected = activeProduct?.foundMemberList?.find(
      (x) => x.selectedMember
    );
    let nonMember = false;
    if (!memberSelected) {
      memberSelected = activeProduct?.additionalMemberList?.find(
        (x) => x.selectedMember
      );
    }
    if (!memberSelected) {
      nonMember = true;
    }
    this.setState({
      foundMemberList: activeProduct?.foundMemberList,
      additionalMemberList: activeProduct?.additionalMemberList,
      nonMember,
    });
  };

  handleContinue = () => {
    const { handleContinue } = this.props;
    const { memberIndex, foundMemberList, additionalMemberList } = this.state;
    let valid = true;

    if (valid) {
      handleContinue({ foundMemberList, additionalMemberList });
    }
  };

  handleBack = () => {
    const { handleBack } = this.props;
    handleBack(AppConstants.APPLICATIONSTEP.BUSINESS_ABOUT_YOU);
  };

  handleChoice = (name, value, type) => {
    let { foundMemberList, additionalMemberList, nonMember } = this.state;

    // Reset all selected members
    foundMemberList = foundMemberList.map((x) => ({
      ...x,
      selectedMember: false,
    }));
    additionalMemberList = additionalMemberList.map((x) => ({
      ...x,
      selectedMember: false,
    }));
    nonMember = false;

    // Handle member selection
    if (type === "none") {
      nonMember = true;
    } else if (type) {
      foundMemberList[value].selectedMember = true; // Select from foundMemberList
    } else {
      additionalMemberList[
        value - foundMemberList.length
      ].selectedMember = true; // Select from additionalMemberList using offset
    }

    // Update state
    this.setState({
      foundMemberList,
      additionalMemberList,
      nonMember,
    });
  };

  verifyData = () => {
    const { memberIndex } = this.state;
    let formIsValid = true;

    if (memberIndex === "none") {
      // do store none value
    } else {
      // do store selected member in the list
    }

    return formIsValid;
  };

  formatPhoneNumber(phoneNumberString) {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return "";
  }

  displayMemberRoles = (member) => {
    const roles = [];
    if (member?.owner) roles.push(STRINGS.BUSINESS_MEMBER.FORM.OWNER_LABEL);
    if (member?.designation) {
      roles.push(member.designation);
    } else if (member?.officeDirector) {
      roles.push(STRINGS.BUSINESS_MEMBER.FORM.OFFICER_DIRECTOR_LABEL);
    }
    if (member?.authorizedSignatory)
      roles.push(STRINGS.BUSINESS_MEMBER.FORM.AUTHORIZED_SIGNATORY_LABEL);

    return roles.join(", ");
  };

  render() {
    const { steps, activeStepID, handleEditPage, activeProduct } = this.props;
    const {
      show,
      memberList,
      memberIndex,
      foundMemberList,
      additionalMemberList,
      nonMember,
    } = this.state;
    const memberDetailComponent = (member, index) => (
      <div className="row details-section__item">
        <div className="col-12 custom-control custom-radio">
          <input
            type="radio"
            id={`memberRadio${index}`}
            value={index}
            name="memberIndex"
            className="custom-control-input"
            onChange={(event) =>
              this.handleChoice("memberIndex", index, member.type)
            }
            checked={!!member.selectedMember}
          />
          <label
            className="custom-control-label"
            htmlFor={`memberRadio${index}`}
          >
            <div className="details-section__item-description col-sm-4">
              {member?.firstName} {member?.lastName}
            </div>
            <div className="details-section__item-description col-sm-4">
              {this.displayMemberRoles(member)}
            </div>
          </label>
        </div>
      </div>
    );

    const memberListComponent = [
      ...(foundMemberList?.length > 0
        ? foundMemberList?.map((member, index) => (
            <>{memberDetailComponent(member, index)}</>
          ))
        : []),
      ...(additionalMemberList?.length > 0
        ? additionalMemberList?.map((member, index) => (
            <>{memberDetailComponent(member, index + foundMemberList.length)}</> // Offset index for additional members
          ))
        : []),
    ];

    const memberListContainerComponent = (
      <>
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                {STRINGS.BUSINESS_MEMBER.FORM.GROUP_LABEL}
              </h3>
            </div>
          </div>

          {memberListComponent}
          <hr />
          <div className="row details-section__item">
            <div className="col-12 custom-control custom-radio">
              <input
                type="radio"
                id="memberRadioNone"
                value="none"
                name="memberIndex"
                className="custom-control-input"
                onChange={(event) =>
                  this.handleChoice("memberIndex", true, "none")
                }
                checked={nonMember}
              />
              <label className="custom-control-label" htmlFor="memberRadioNone">
                <div className="details-section__item-description col-sm-4">
                  {STRINGS.BUSINESS_ABOUT_YOU.NONE}
                </div>
                <div className="details-section__item-description col-sm-4"></div>
              </label>
            </div>
          </div>
        </div>
      </>
    );

    const actionComponent = (
      <div className="[ business-about-you-container ] [ confirm-account-container ]">
        <Stepper steps={steps} active={activeStepID} />

        <div className="[ form-title ]">{STRINGS.BUSINESS_REVIEW.TITLE}</div>

        <div className="[ form-container ]">
          <div className="[ row ]">
            <div className="[ col-12 ]">
              <div className="[ mb-3 ]">
                <div className="[ form-subtitle ]">
                  {STRINGS.BUSINESS_ABOUT_YOU.SUB_HEADER}
                </div>
                <div className="[ form-description ]">
                  {STRINGS.BUSINESS_ABOUT_YOU.DESCRIPTION1}
                </div>
                <div className="[ form-description ]">
                  {STRINGS.BUSINESS_ABOUT_YOU.DESCRIPTION2}
                </div>
                <div className="[ form-description ]">
                  {STRINGS.BUSINESS_ABOUT_YOU.DESCRIPTION3}
                </div>

                {/* 
                        BUSINESS COMPLIANCE
                    */}
                {memberListContainerComponent}
              </div>
            </div>
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="button"
                className="[ btn  submit-btn ] [ w-100 ]"
                onClick={this.handleContinue}
              >
                {STRINGS.COMMON.CONTINUEBTN}
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <AuthBody
        blockBack={true}
        actionComponent={actionComponent}
        memberCreation
        handleBack={this.handleBack}
      />
    );
  }
}

BusinessAboutYou.propTypes = {
  getDataFromServer: PropTypes.func,
  handleContinue: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleEditPage: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

BusinessAboutYou.defaultProps = {
  getDataFromServer: () => {},
  handleContinue: () => {},
  handleEditPage: () => {},
  steps: [],
  activeStepID: -1,
};

export default BusinessAboutYou;
